module.exports = __webpack_public_path__ + "components/flag/static/square/by-dc46e5ba118607dda1eec9dd320b7dab.svg";